/* eslint-disable no-mixed-operators */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
import NumberUtils from 'lib/NumberUtils';
import { PayType } from 'utils/enum/PayrollEnum';
import { PAY_TYPE } from 'utils/enum/ServiceInvoiceEnum';

export default class CalculationServiceMethodsHelper {
    static getLaborCostLocal(payInfo) {
        const {
            payType = '',
            salary = 0,
            hours = 0,
        } = payInfo;

        let laborCost = 0;

        const dividerSalaryRate = 2080; // TODO: this should be part of settings

        if (payType) {
            if (payType?.toLowerCase() === 'salary') laborCost = (salary / dividerSalaryRate) * hours;
            else laborCost = salary * hours;
        }

        return NumberUtils.round(laborCost);
    }

    static setCalculationsLocal(record, serviceSettings, customFields = []) {
        const { jobs } = record;

        const {
            hourlyLaborRate,
            customerPayHourlyRate,
            shopSuppliesPercent,
            shopSuppliesLimit,
            surplusTax,
            customTaxRateValue,
            customTaxRateEnabled,
            noTaxOnRoLabor,
            technicianSettings,
            chargeSalesTaxASR,
            chargeSalesTaxOnWarrantyDeductable,
            chargeSalesTaxOnWarrantyParts,
            shopSuppliesType,
            roCostBasedOnHourlyRateMapping,
        } = serviceSettings;

        const jobsApproved = jobs.filter((c) => c.approved);

        let warrantyCovered = 0;
        let internalCovered = 0;
        let partCost = 0;

        let totalParts = 0;
        let totalLabor = 0;
        let totalPartsTaxable = 0;
        let totalLaborTaxable = 0;
        let totalSubletCost = 0;
        let totalSubletPrice = 0;
        let totalLaborCost = 0;
        let totalDiscount = 0;
        let totalCustomerPay = 0;
        let totalCustomerTax = 0;
        let totalFees = 0;
        let totalFeesTaxable = 0;
        let totalFeesCustomerPay = 0;

        const defaultSurplusSalesTax = 7; // TODO: this should be in settings
        const surplusSalesTax = customTaxRateEnabled ? customTaxRateValue : (surplusTax ?? defaultSurplusSalesTax);
        const surplusTaxRate = surplusSalesTax / 100;

        jobsApproved.forEach((item) => {
            const payTypeUpper = item.payType.toUpperCase();
            const isASR = payTypeUpper === PAY_TYPE.AFTER_SALE_REPAIR;
            const payInfo = technicianSettings.find((c) => Number(c.userId) === Number(item.technicianId));
            item.isFlatRate = payInfo?.payType?.toUpperCase() === PayType.FLAT_RATE.toUpperCase();

            if (record.inHouse) {
                if (roCostBasedOnHourlyRateMapping) {
                    item.hourlyRate = item.isFlatRate ? payInfo?.salary || 0 : 0;
                } else {
                    item.hourlyRate = hourlyLaborRate;
                }
            } else if (payTypeUpper === PAY_TYPE.WE_OWE || isASR) {
                item.hourlyRate = hourlyLaborRate;
            } else {
                item.hourlyRate = customerPayHourlyRate;
            }

            item.laborTotal = NumberUtils.toFixed(item.isHrsChecked ? item.hours * item.hourlyRate : item.laborTotal);

            item.laborCost = this.getLaborCostLocal({
                ...payInfo,
                hours: item.hours,
            });

            item.partsTotal = 0;
            item.partsTax = 0;
            const newParts = [];
            item?.parts?.forEach((part) => {
                const clonePart = { ...part };
                const isPartTaxable = record.isTaxable && part.isTaxable && (
                    (
                        [PAY_TYPE.CUSTOMER_PAY, PAY_TYPE.WARRANTY_LABOR_ONLY, PAY_TYPE.WARRANTY_PAY_SUBLET].includes(payTypeUpper)
                        || (isASR && chargeSalesTaxASR)
                        || ([PAY_TYPE.WARRANTY_PARTS_ONLY, PAY_TYPE.WARRANTY_PARTS_LABOR].includes(payTypeUpper) && chargeSalesTaxOnWarrantyParts)
                    )
                );

                if (!part.isFee) {
                    const calcPartTaxAmount = isPartTaxable ? NumberUtils.toFixed(part.netPrice * part.quantity) * surplusTaxRate : 0;
                    clonePart.partTaxAmount = NumberUtils.toFixed(calcPartTaxAmount);

                    item.partsTotal += NumberUtils.toFixed(part.netPrice * part.quantity);
                    item.partsTax += NumberUtils.toFixed(calcPartTaxAmount);
                    partCost += NumberUtils.toFixed(part.partCost * part.quantity);
                } else {
                    const currentFee = NumberUtils.round(part.netPrice * part.quantity);
                    totalFees += currentFee;
                    if (isPartTaxable) {
                        totalFeesTaxable += currentFee;
                        clonePart.feeTaxAmount = currentFee * surplusTaxRate;
                    }

                    if (![PAY_TYPE.WE_OWE, PAY_TYPE.AFTER_SALE_REPAIR].includes(payTypeUpper)) totalFeesCustomerPay += currentFee;
                }

                newParts.push(clonePart);
            });

            item.partsTotal = NumberUtils.toFixed(item.partsTotal);
            item.partsTax = NumberUtils.toFixed(item.partsTax);
            item.parts = newParts;

            if (record.laborDiscount) item.discount = 0;

            switch (payTypeUpper) {
            case PAY_TYPE.WARRANTY_PARTS_LABOR:
                warrantyCovered += item.partsTotal + item.laborTotal;
                item.warrantyCovered = item.partsTotal + item.laborTotal;
                break;
            case PAY_TYPE.WARRANTY_LABOR_ONLY:
                warrantyCovered += item.laborTotal;
                item.warrantyCovered = item.laborTotal;
                break;
            case PAY_TYPE.WARRANTY_PARTS_ONLY:
                warrantyCovered += item.partsTotal;
                item.warrantyCovered = item.partsTotal;
                break;
            case PAY_TYPE.WARRANTY_PAY_SUBLET:
                warrantyCovered += item.subletPrice;
                item.warrantyCovered = item.subletPrice;
                break;
            default:
                warrantyCovered += 0;
                break;
            }

            if (([PAY_TYPE.INTERNAL, PAY_TYPE.AFTER_SALE_REPAIR, PAY_TYPE.WE_OWE].includes(payTypeUpper)) && !record.inHouse) {
                internalCovered += NumberUtils.toFixed(item.partsTotal + item.laborTotal + item.subletPrice);
                item.internalCovered = NumberUtils.toFixed(item.partsTotal + item.laborTotal + item.subletPrice);
            }

            item.customerPay = payTypeUpper === PAY_TYPE.CUSTOMER_PAY ? NumberUtils.toFixed(item.partsTotal + item.laborTotal + item.subletPrice) : 0;

            item.laborTax = NumberUtils.toFixed((
                [PAY_TYPE.CUSTOMER_PAY, PAY_TYPE.WARRANTY_PARTS_ONLY, PAY_TYPE.WARRANTY_PAY_SUBLET].includes(payTypeUpper) && record.isTaxable)
                ? (noTaxOnRoLabor ? 0 : item.laborTotal) * surplusTaxRate : 0);

            item.customerTax = NumberUtils.toFixed(Number(item.partsTax) + Number(item.laborTax)
            + NumberUtils.round((
                [PAY_TYPE.CUSTOMER_PAY, PAY_TYPE.WARRANTY_PARTS_LABOR, PAY_TYPE.WARRANTY_PARTS_ONLY, PAY_TYPE.WARRANTY_LABOR_ONLY].includes(payTypeUpper)
                && record.isTaxable)
                ? (Number(item.subletPrice) * Number(surplusTaxRate)) : 0));

            const currentPartTotal = NumberUtils.toFixed(item.partsTotal);
            const currentLaborTotal = NumberUtils.toFixed(item.laborTotal);

            totalParts += currentPartTotal;
            totalLabor += currentLaborTotal;
            totalPartsTaxable += ![PAY_TYPE.WE_OWE, PAY_TYPE.AFTER_SALE_REPAIR].includes(payTypeUpper) ? currentPartTotal : 0;
            totalLaborTaxable += ![PAY_TYPE.WE_OWE, PAY_TYPE.AFTER_SALE_REPAIR].includes(payTypeUpper) ? currentLaborTotal : 0;
            totalSubletCost += NumberUtils.toFixed(item.subletCost);
            totalSubletPrice += NumberUtils.toFixed(item.subletPrice);
            totalLaborCost += NumberUtils.toFixed(item.laborCost);
            totalDiscount += NumberUtils.toFixed(item.discount);
            totalCustomerPay += NumberUtils.toFixed(item.customerPay);
            totalCustomerTax += NumberUtils.toFixed(item.customerTax);
        });

        const totalWarrantyCovered = NumberUtils.toFixed(warrantyCovered);
        const totalInternalCovered = NumberUtils.toFixed(internalCovered);
        const totalPartCost = NumberUtils.toFixed(partCost);

        const discountAmount = NumberUtils.toFixed(record.laborDiscount ? totalLabor * record.discountPercentage / 100 : totalDiscount);

        let shopSupplies = NumberUtils.toFixed(record.overrideShopSuppliesFee ? record.shopSupplies : 0);
        let shopAndFees = NumberUtils.toFixed(Number(record.cancellationFee || 0)
            + Number(record.storageFee || 0) + shopSupplies);

        if (shopSuppliesPercent > 0 && !record.overrideShopSuppliesFee) {
            const shopSuppliesAmt = (
                (['all', 'parts'].includes(shopSuppliesType.toLowerCase()) ? totalPartsTaxable : 0)
                + (['all', 'labor'].includes(shopSuppliesType.toLowerCase()) ? totalLaborTaxable : 0)
            ) * (shopSuppliesPercent / 100);

            shopSupplies = NumberUtils.toFixed((shopSuppliesAmt > shopSuppliesLimit && shopSuppliesLimit > 0)
                ? shopSuppliesLimit : shopSuppliesAmt);

            if (record.inHouse) shopSupplies = 0;

            shopAndFees = Number(record.cancellationFee || 0)
                + Number(record.storageFee || 0) + Number(shopSupplies);
        }

        let customFieldsTotal = 0;
        let customFieldsTaxableAmount = 0;
        if (customFields?.length > 0) {
            customFieldsTotal = customFields.reduce((a, b) => a + Number(b.value ?? 0), 0);
            customFieldsTaxableAmount = customFields.filter((i) => i.taxable).reduce((a, b) => a + Number(b.value ?? 0), 0);
        }

        totalCustomerPay += NumberUtils.toFixed(record.warrantyDeductable + shopAndFees + totalFeesCustomerPay + customFieldsTotal);
        if (record.isTaxable) {
            totalCustomerTax += NumberUtils.toFixed((shopAndFees + totalFeesTaxable + customFieldsTaxableAmount) * surplusTaxRate)
            + (chargeSalesTaxOnWarrantyDeductable ? (Number(record.warrantyDeductable) * Number(surplusTaxRate)) : 0);
        } else totalCustomerTax = 0;

        const totalInvoice = NumberUtils.toFixed(totalParts + totalLabor + totalSubletPrice + shopAndFees + totalFeesCustomerPay + customFieldsTotal
            + totalCustomerTax + record.warrantyDeductable - totalWarrantyCovered - totalInternalCovered - discountAmount);

        record.shopSupplies = NumberUtils.toFixed(shopSupplies);
        record.warranty = NumberUtils.toFixed(totalWarrantyCovered);
        record.discount = NumberUtils.toFixed(discountAmount);
        record.totalLabor = NumberUtils.toFixed(totalLabor);
        record.totalParts = NumberUtils.toFixed(totalParts);
        record.partsProfit = NumberUtils.toFixed(totalParts - totalPartCost);
        record.laborProfit = NumberUtils.toFixed(totalLabor - totalLaborCost);
        record.total = NumberUtils.toFixed(totalInvoice);
        record.tax = NumberUtils.toFixed(totalCustomerTax);
        record.totalSubletCost = NumberUtils.toFixed(totalSubletCost);
        record.totalSubletPrice = NumberUtils.toFixed(totalSubletPrice);
        record.customerPay = NumberUtils.toFixed(totalCustomerPay);
        record.surplusSalesTax = NumberUtils.toFixed(surplusSalesTax);
        record.fees = totalFees;

        return record;
    }
}
